import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IActivationServiceRequestTemplateModel } from '@apps-common/types/portal/service-request'

export const QUERY_GET_UNIT_ACTIVATION_TEMPLATE_BY_ID = (id: number | undefined) => ['getUnitActivationTemplateById', id]

export const getUnitActivationTemplateById = async (id: number): Promise<IActivationServiceRequestTemplateModel> =>
  axios.get(`/UnitActivation/GetActivationTemplate?id=${id}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitActivationTemplateById

type Props = {
  config?: QueryConfig<QueryFnType>
  id: number | undefined
}

export const useGetUnitActivationTemplateById = ({ config, id }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_UNIT_ACTIVATION_TEMPLATE_BY_ID(id),
    queryFn: () => getUnitActivationTemplateById(id || 0)
  })
